import { ApiResponse } from "interface/response"
import { AxiosApi } from "./index";
import { PickupList } from "interface/pickList";
import { useInfoStore } from "store/error";
import { FilterOption } from "interface";

export interface PickListFilter extends FilterOption{
    buyerLedgerNumber?: string
    buyerId?: string,
    buyerName?: string,
}
export async function getPickListApi(filter: PickListFilter) {
    const apiUri = "PickList/";

    try {
        console.log('filter', filter);
        const menuResponse = await AxiosApi.get<ApiResponse<PickupList[]>>(apiUri, {
            params: filter
        })
        return menuResponse.data.data
    } catch (error: any) {
          const { setError } = useInfoStore.getState();
          setError(error);
          throw  error
       }
}
